var _path, _path2, _g, _path3, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViettelPayActive = function SvgViettelPayActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    d: "M2.75 9.58a.75.75 0 0 1 .75-.75h28.879a.75.75 0 0 1 .75.75V27.5a.75.75 0 0 1-.75.75H3.5a.75.75 0 0 1-.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.494 10.574a1 1 0 0 1 1-1h26.89a1 1 0 0 1 1 1v15.932a1 1 0 0 1-1 1H4.495a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#viettel-pay-active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#viettel-pay-active_svg__b)",
    d: "M20.636 25.194c-.467.86-1.63 1.037-2.35.358l-9.49-8.966c-.922-.87-.432-2.407.818-2.568L25.06 12.03c1.219-.157 2.114 1.136 1.53 2.21z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#viettel-pay-active_svg__c)",
    fillOpacity: 0.8,
    d: "M25.297 16.795c.982.566 1.019 1.966.067 2.565l-10.681 6.725c-.969.61-2.245-.054-2.309-1.2l-.733-13.306c-.066-1.185 1.208-1.96 2.241-1.365z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#viettel-pay-active_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.358 16.27a.3.3 0 0 1-.16.08 1 1 0 0 1-.242.03s.017-.01-.056-.03c-.072-.018-.055-.046-.087-.08a19 19 0 0 1-.706-.834q-.038-.05-.038-.075 0-.084.124-.083h.477q.093 0 .142.02a.2.2 0 0 1 .088.08l.246.38q.015.024.055.024t.061-.024l.332-.436q.033-.041.07-.046l.054-.001.29.003q.05 0 .069.027a.04.04 0 0 1 .008.026q0 .015-.059.085-.055.068-.296.383-.237.314-.372.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.084 15.275h.094q.107 0 .14.031.035.033.045.134.013.099.013.39 0 .287-.02.423-.008.035-.053.062a.23.23 0 0 1-.117.031c-.096.004.258.006.132.006-.127 0-.129-.002-.242-.006a.25.25 0 0 1-.119-.03q-.043-.028-.05-.063a3 3 0 0 1-.02-.423q0-.29.01-.39.012-.1.045-.133.035-.032.142-.032M19.322 16.375a.25.25 0 0 1-.122-.027.14.14 0 0 1-.063-.094 3 3 0 0 1-.012-.39q0-.327.017-.427.021-.129.18-.132c.121-.002-.023 0 .863 0q.15 0 .15.115 0 .09-.132.09h-.557a.15.15 0 0 0-.086.022.07.07 0 0 0-.03.055v.11q0 .046.068.046h.46q.042 0 .061.005a.07.07 0 0 1 .041.028q.018.021.018.072t-.03.067a.2.2 0 0 1-.094.017h-.413q-.064 0-.088.02-.023.018-.023.058v.075q0 .066.104.066l1.167.003q.045 0 .08.017.036.016.036.07a.13.13 0 0 1-.043.097.14.14 0 0 1-.1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.122 15.673-.002.306q0 .067.032.102.036.032.145.032h.64q.117.001.117.107 0 .081-.033.118t-.134.038a41 41 0 0 1-.707.006h-.442a.4.4 0 0 1-.15-.027q-.054-.027-.062-.075a3 3 0 0 1-.02-.42q0-.288.01-.388.012-.101.048-.133.035-.034.139-.034l.23-.002q.106 0 .139.034.035.034.043.109t.007.227M17.602 16.26q-.003.033-.048.063a.25.25 0 0 1-.122.03c-.096.005.09.003-.045.003s.113.004 0 0a.25.25 0 0 1-.122-.03q-.045-.03-.048-.064c-.005-.155 0-.346 0-.455q0-.165.003-.242-.001-.059-.086-.058h-.228a.2.2 0 0 1-.086-.016.07.07 0 0 1-.038-.053l-.003-.08c0-.028.006.047.008.028q.004-.03.04-.046a.2.2 0 0 1 .081-.017c.22-.002-.157-.005.218-.005q.561 0 .804.003a.2.2 0 0 1 .079.017q.038.015.04.046c.004.02 0-.056 0-.03q0 .04-.002.077-.007.069-.124.069h-.228q-.086 0-.086.053.008.195.008.35c0 .104-.01.262-.015.357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.729 16.383a.25.25 0 0 1-.122-.027.14.14 0 0 1-.063-.094 3 3 0 0 1-.013-.39q0-.327.018-.427.02-.129.18-.132c.121-.002.46-.003 1.345-.003q.15 0 .15.115 0 .09-.132.09l-1.04.003a.16.16 0 0 0-.085.022.07.07 0 0 0-.03.055v.11q0 .045.068.046h.46q.041 0 .061.005a.07.07 0 0 1 .04.027q.018.023.018.072 0 .051-.03.068a.2.2 0 0 1-.094.017h-.412q-.063 0-.089.02-.023.018-.023.058v.075q0 .066.104.066h.701q.046 0 .081.017.036.015.036.07a.13.13 0 0 1-.043.097.14.14 0 0 1-.102.043zM18.717 16.263q-.002.033-.048.063a.25.25 0 0 1-.121.03c-.096.004.09.002-.046.002-.135 0 .113.005 0 0a.25.25 0 0 1-.121-.03q-.046-.03-.048-.063c-.005-.155 0-.346 0-.455q0-.166.002-.243 0-.058-.086-.058h-.228a.2.2 0 0 1-.086-.015.06.06 0 0 1-.038-.054l-.002-.08c0-.027.005.048.007.029q.005-.031.04-.046a.2.2 0 0 1 .081-.017c.22-.002-.157-.006.218-.006h1.079a.2.2 0 0 1 .078.018q.04.015.04.046c.004.02.001-.056.001-.03q0 .04-.002.077-.008.069-.124.069l-.502.002q-.087 0-.086.054.007.193.007.35c0 .104-.01.262-.015.357"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#viettel-pay-active_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.087 20.576a.232.232 0 1 1-.464 0V17.51a.227.227 0 0 1 .454 0v.139h.015a.85.85 0 0 1 .33-.307 1.04 1.04 0 0 1 .514-.123q.262 0 .475.094.217.094.37.261.158.169.242.396.084.221.084.479 0 .256-.084.484a1.125 1.125 0 0 1-.607.662 1.2 1.2 0 0 1-.49.093q-.251 0-.474-.108a.86.86 0 0 1-.35-.306h-.015zm1.54-2.128q0-.163-.049-.316a.8.8 0 0 0-.148-.272.7.7 0 0 0-.247-.188.8.8 0 0 0-.336-.069.8.8 0 0 0-.326.07.8.8 0 0 0-.247.187.9.9 0 0 0-.162.272 1 1 0 0 0-.055.32q0 .17.054.322.06.153.163.271.105.114.247.183.15.07.326.07.193 0 .336-.07a.76.76 0 0 0 .395-.464q.05-.154.05-.316M16.412 18.514q0-.287.089-.533.089-.252.247-.435.162-.183.385-.287.227-.103.494-.103.223 0 .4.079.183.075.316.188v-.005a.203.203 0 0 1 .405 0v2.202c0 .123-.1.223-.222.223a.22.22 0 0 1-.22-.223q0-.063-.002-.154c-.04.052-.017.062-.07.115a.9.9 0 0 1-.395.227 1.111 1.111 0 0 1-.726-.06 1.1 1.1 0 0 1-.365-.266 1.4 1.4 0 0 1-.247-.415 1.6 1.6 0 0 1-.089-.553m1.255.933q.187 0 .355-.088a.9.9 0 0 0 .282-.233v-1.378a1.1 1.1 0 0 0-.297-.148 1 1 0 0 0-.336-.059.747.747 0 0 0-.583.267.9.9 0 0 0-.162.301q-.06.178-.06.39 0 .207.06.385.06.174.168.302a.75.75 0 0 0 .573.262M20.447 19.072h.01l.593-1.685a.227.227 0 1 1 .426.158l-1.014 2.584q-.06.148-.129.262a.8.8 0 0 1-.163.197.6.6 0 0 1-.222.129.9.9 0 0 1-.296.044q-.074 0-.154-.01c-.088-.006-.145-.09-.136-.179l.002-.02c.014-.121.136-.196.258-.196q.182 0 .272-.104a1 1 0 0 0 .163-.286l.148-.39-.862-2.012a.236.236 0 1 1 .437-.18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "viettel-pay-active_svg__a",
    width: 19.454,
    height: 15.451,
    x: 7.818,
    y: 12.016,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_12059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5_12059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "viettel-pay-active_svg__d",
    width: 9.185,
    height: 1.312,
    x: 12.969,
    y: 15.274,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.533333 0 0 0 0 0.568627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_12059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5_12059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "viettel-pay-active_svg__e",
    width: 8.069,
    height: 3.853,
    x: 13.523,
    y: 17.156,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.533333 0 0 0 0 0.568627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_12059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5_12059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "viettel-pay-active_svg__b",
    x1: 27.287,
    x2: 12.697,
    y1: 22.469,
    y2: 11.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F05A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "viettel-pay-active_svg__c",
    x1: 12.866,
    x2: 14.461,
    y1: 11.4,
    y2: 25.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20C69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B7E6"
  })))));
};
export default SvgViettelPayActive;